import React from 'react'
import { Button } from '@/components/ui/button'
import type { LucideIcon } from 'lucide-react'

interface NavigationItemProps {
  icon: LucideIcon
  label: string
  onClick?: () => void
  isActive?: boolean
  isCollapsed?: boolean
}

export const NavigationItem: React.FC<NavigationItemProps> = ({
  icon: Icon,
  label,
  onClick,
  isActive = false,
  isCollapsed = false
}) => {
  return (
    <div className="relative group w-full">
      <Button
        variant="ghost"
        className={`
          w-full ${isCollapsed ? 'justify-center px-2' : 'justify-start gap-3 px-4'} h-11 rounded-lg
          transition-all duration-200 ease-in-out
          ${isActive 
            ? 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90' 
            : 'text-muted-foreground hover:text-foreground hover:bg-muted'
          }
          active:scale-[0.98]
        `}
        onClick={onClick}
      >
        <Icon className={`
          ${isCollapsed ? 'w-5 h-5' : 'w-4 h-4'} transition-all duration-200
          ${isActive ? 'text-primary-foreground' : 'text-muted-foreground group-hover:text-foreground'}
          group-hover:scale-110
        `} />
        {!isCollapsed && (
          <span className="text-sm font-medium transition-all duration-200 whitespace-nowrap">
            {label}
          </span>
        )}
      </Button>
      
      {/* Tooltip for collapsed state */}
      {isCollapsed && (
        <div className="absolute left-full ml-2 px-2 py-1 bg-popover text-popover-foreground text-sm rounded-md shadow-md opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 whitespace-nowrap z-50">
          {label}
        </div>
      )}
    </div>
  )
}